import * as React from 'react';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/X';

export default function Footer() {
  return (
    <Container
      maxWidth="xl"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: (theme) => theme.spacing(4),
      }}
    >
      <Box
        sx={{
          borderTop: '1px solid',
          borderColor: 'divider',
          width: '100%',
        }}
      />
      <Grid container spacing={4} sx={{ py: { xs: 12, md: 14 } }}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="h6" gutterBottom>
            Über uns
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            Wir bieten innovative Lösungen für Ihre digitalen Herausforderungen.
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="h6" gutterBottom>
            Social Media
          </Typography>
          <Stack direction="row" spacing={1}>
            <IconButton
              color="inherit"
              href="https://github.com/mui/"
              aria-label="GitHub"
              size="small"
            >
              <GitHubIcon />
            </IconButton>
            <IconButton
              color="inherit"
              href="https://twitter.com/MUI_hq"
              aria-label="X"
              size="small"
            >
              <TwitterIcon />
            </IconButton>
            <IconButton
              color="inherit"
              href="https://www.linkedin.com/company/mui/"
              aria-label="LinkedIn"
              size="small"
            >
              <LinkedInIcon />
            </IconButton>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="h6" gutterBottom>
            Rechtliches
          </Typography>
          <Stack spacing={0.5}>
            <Link href="/datenschutz" color="text.secondary" underline="hover">
              Datenschutz
            </Link>
            <Link href="/nutzungsbedingungen" color="text.secondary" underline="hover">
              Nutzungsbedingungen
            </Link>
            <Link href="/kontakt" color="text.secondary" underline="hover">
              Kontakt
            </Link>
            <Link href="/impressum" color="text.secondary" underline="hover">
              Impressum
            </Link>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  );
}
